var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77268 25.5C2.05657 25.5 1.4431 25.2446 0.932266 24.7337C0.421432 24.2229 0.166016 23.6094 0.166016 22.8933V3.10667C0.166016 2.39056 0.421432 1.77708 0.932266 1.26625C1.4431 0.755417 2.05657 0.5 2.77268 0.5H29.226C29.9421 0.5 30.5556 0.755417 31.0664 1.26625C31.5773 1.77708 31.8327 2.39056 31.8327 3.10667V22.8933C31.8327 23.6094 31.5773 24.2229 31.0664 24.7337C30.5556 25.2446 29.9421 25.5 29.226 25.5H2.77268ZM29.7385 4.485L16.7139 13.0138C16.5973 13.0751 16.482 13.1267 16.3681 13.1683C16.2539 13.21 16.131 13.2308 15.9993 13.2308C15.8677 13.2308 15.7448 13.21 15.6306 13.1683C15.5167 13.1267 15.4049 13.0751 15.2952 13.0138L2.26018 4.485V22.8933C2.26018 23.0428 2.30824 23.1656 2.40435 23.2617C2.50046 23.3578 2.62324 23.4058 2.77268 23.4058H29.226C29.3755 23.4058 29.4982 23.3578 29.5944 23.2617C29.6905 23.1656 29.7385 23.0428 29.7385 22.8933V4.485ZM15.9993 11.2883L29.4031 2.59417H2.6231L15.9993 11.2883ZM2.26018 4.81833V3.31042V3.355V2.59417V3.34083V3.28708V4.81833Z",
    fill: "#082A6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.79b8e7404fe816ad05fe7f8c350eeea8.svg";
export { ForwardRef as ReactComponent };